// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Overlay{background:rgba(0,0,0,.5);height:100vh;position:fixed;right:0;top:0;width:100vw}", ""]);
// Exports
module.exports = exports;
